import { forwardRef } from "react";

import { FormAutocompleteProps } from "@shared/components/Form/types";
import { Form } from "@shared/components/Form";
import { getLevelsService } from "@modules/levels/services/queries/listLevels/service";

export const LevelsAutocomplete = forwardRef<
  HTMLInputElement,
  Omit<FormAutocompleteProps, "options">
>((props, ref) => {
  return (
    <Form.Autocomplete {...props} ref={ref} queryHook={getLevelsService} />
  );
});

LevelsAutocomplete.displayName = "LevelsAutocomplete";
